import {RESULT_CONTEXT} from '../data/SearchContext';

export const SearchState = {
  context: RESULT_CONTEXT
};
